import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import './locationApprovals.css';


const LocationApprovalsList = ({
  approvalList,
  getApprovalList,
  acceptApproval,
  rejectApproval,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    if (getApprovalList !== null) {
      (async () => {
        setIsLoading(true);
        await getApprovalList();
        setIsLoading(false);
      })();
    }
  }, [getApprovalList]);

  const Headers = [
    'Site No',
    'Site Name',
    'Current Lat.',
    'Current Long.',
    'New Lat.',
    'New Long.',
    'Current Location',
    'Requested By',
    'Accept/Reject',
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'siteName',
      'oldLatitude',
      'oldLongitude',
      'newLatitude',
      'newLongitude',
      'current_location',
      'requestedBy',
    ];

    if (approvalList !== {} && approvalList.resultSets) {
      const data = approvalList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            'Approve/Reject': '',
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(approvalList.total / approvalList.per_page));
    }
  }, [approvalList]);

  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
      await acceptApproval(data.actionObj.id).then(async (response) => {
        if (response) {
          await getApprovalList();
          setIsModal(true);
        }
      });
    } else {
      setIsModal(true);
    }
  };

  const handleModalHide = () => setIsModal(false);
  const handleRejectModalHide = () => setIsSuccessModel(false);

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link
          to={`${baseUrl}/site-listing`}
          onClick={func}
          className="btn btn-primary mb-4"
        >
          
          {localization.viewSites} <img src={Images?.ArrowRight} alt="" />
        </Link>
        <div className="viewsitesbtn">
        <Button onClick={func} className="btn btn-transparent">
          {localization.returnToApproval}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
        </div>
      </div>
    );
  };

  const handleContinue = async () => {
    await rejectApproval(actionData.actionObj.id).then(async (response) => {
      if (response) {
        await getApprovalList();
        setIsModal(false);
        setIsSuccessModel(true);
      }
    });
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getApprovalList(val.selected + 1);
    setIsLoading(false);
  };
  return (
    <Layout title={localization.locationApprovals} isLoading={isLoading}>
      <TableSection
        data={listData}
        headers={Headers}
        detailList={approvalList && approvalList.resultSets}
        isId={false}
        onChange={(data) => updateApproval(data)}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={approvalList?.from}
      />
      <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={handleModalHide}
        actionData={actionData}
      >
        {actionData && actionData.action === 'reject' ? (
          <div className="modal-body">
            <div className="text-center">
              <h5>{localization.rejectApproval}</h5>
              <Button className="btn btn-primary mb-4" onClick={handleContinue}>
                {localization.continue} <img src={Images?.ArrowRight} alt="" />
              </Button>
              <Button
                onClick={() => setIsModal(false)}
                className="btn btn-transparent"
              >
                {localization.returnToApproval}{' '}
                <img src={Images?.ArrowRight} alt="" />
              </Button>
            </div>
          </div>
        ) : (
          <Fragment>
            {successIconBox(localization.approveSuccess, handleModalHide)}
          </Fragment>
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox(
          localization.locationLatLongRrejectedSuccessfully,
          handleRejectModalHide
        )}
      </ModalPop>
    </Layout>
  );
};

LocationApprovalsList.propTypes = {
  approvalList: PropTypes.any,
  getApprovalList: PropTypes.any,
  acceptApproval: PropTypes.any,
  rejectApproval: PropTypes.any,
};

export default LocationApprovalsList;
